import { getFormattedDate } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';
import { isDateValidAndPast } from 'src/components/oneCorp/features/MealCredit/utils/isDateValidAndPast';

/**
 * Generates the deactivation text based on the expiration date.
 *
 * @param expirationDate - The expiration date to evaluate.
 * @returns A string describing the deactivation status with the formatted date.
 */
export function getDeactivationText(expirationDate: Date): string {
  const status = isDateValidAndPast(expirationDate)
    ? 'Deactivated'
    : 'Deactivates';
  const formattedDate = getFormattedDate(expirationDate);

  return `${status} ${formattedDate}`;
}
